import { Form } from 'antd';

import { UnsafePageDescription, UnsafePageTitle, UnsafePageWrapper } from '@style/pages/page.style';

import GithubIcon from '@asset/github.icon.svg?react';
import GoogleIcon from '@asset/google.icon.svg?react';
import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Text } from '@atom/typography/typography';
import { LoginProviderEnum } from '@enum/login-provider.enum';
import { ColorEnum } from '@enum/style/color.enum';
import { TestIdsEnum } from '@enum/test-ids.enum';
import { LoginForm } from '@form/login';
import { useSSOLogin } from '@hook/auth/use-sso-login.hook';
import { getTestId } from '@util/data/get-test-id';

import { ButtonSpace, ButtonTitle, Divider, FormWrapper, NewUserParagraph } from './login.style';
import { useLogin } from './use-login.hook';

export const LoginPage = () => {
  const { error, isLoading, form, onLogin, onSignUpPage } = useLogin();
  const { error: ssoError, isLoading: ssoLoading, handleLoginProvider } = useSSOLogin();

  return (
    <UnsafePageWrapper>
      <UnsafePageTitle>Login</UnsafePageTitle>
      <UnsafePageDescription>Login with Google, Github or email below.</UnsafePageDescription>
      <FormWrapper>
        <ButtonSpace direction='vertical' size={16}>
          <Button
            icon={<GoogleIcon />}
            type={ButtonTypeEnum.Primary}
            block
            ghost
            onClick={handleLoginProvider(LoginProviderEnum.Google)}
          >
            <ButtonTitle>Sign in with Google</ButtonTitle>
          </Button>
          <Button
            icon={<GithubIcon />}
            type={ButtonTypeEnum.Primary}
            block
            ghost
            onClick={handleLoginProvider(LoginProviderEnum.Github)}
          >
            <ButtonTitle>Sign in with Github</ButtonTitle>
          </Button>
        </ButtonSpace>
        <Divider />
        <Form.Provider onFormFinish={onLogin}>
          <LoginForm error={error ?? ssoError} form={form} isLoading={isLoading || ssoLoading} />
        </Form.Provider>
        <Divider />
        <NewUserParagraph>Are you a new user?</NewUserParagraph>
        <Button
          type={ButtonTypeEnum.Primary}
          block
          ghost
          onClick={onSignUpPage}
          {...getTestId(TestIdsEnum.LoginLinkSignUp)}
        >
          <Text color={ColorEnum.Black100} letterSpacing={1.4} level='m' weight={500}>
            SIGN UP
          </Text>
        </Button>
      </FormWrapper>
    </UnsafePageWrapper>
  );
};
